import { Select } from 'antd';
import { useState } from 'react';
import styled from 'styled-components';

import { Flex, Space, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import { useModalContext } from '@/components/Modal/Modal';
import { MainText } from '@/components/Typography/NamedTypo';
import Typo from '@/components/Typography/Typo';
import {
  defaultGlobalSearchConfig,
  type GLOBAL_SEARCH_VIEW,
  GlobalSearchViewConfigMap,
} from '@/features/GlobalSearch/types/searchConst';
import useGlobalSearchStore from '@/stores/GlobalSearchStore';
import { modalStyle } from '@/styles/style';

const AddSearchTabModal = () => {
  const addSearchView = useGlobalSearchStore((state) => state.addSearchView);
  const views = useGlobalSearchStore((state) => state.search_view_config);
  const { closeModal } = useModalContext();

  const remainViews = GlobalSearchViewConfigMap.toArray()
    .filter((config) => {
      return (
        !views.includes(config.value) &&
        !defaultGlobalSearchConfig.includes(config.value)
      );
    })
    .map((config) => {
      return {
        label: config.label.name,
        value: config.value,
      };
    });

  const [selectedView, setSelectedView] = useState<GLOBAL_SEARCH_VIEW | null>(
    remainViews[0]?.value || null,
  );

  const submit = async () => {
    if (!selectedView) return;
    addSearchView(selectedView);
    closeModal();
  };

  return (
    <Style>
      <Typo type="label0" weight="sb">
        Add view
      </Typo>
      <Space h={32} />
      <VFlex g={8}>
        <MainText>Select data to view</MainText>
        <Select
          placeholder="No remain view type"
          options={remainViews}
          value={selectedView}
          onChange={setSelectedView}
        />
      </VFlex>
      <Space h={32} />
      <Flex j="flex-end" g={16}>
        <Button variant="outlined" sizeType="m" onClick={closeModal}>
          Cancel
        </Button>
        <Button
          variant="primary"
          sizeType="m"
          style={{ width: 140 }}
          onClick={submit}
          disabled={!selectedView}
        >
          Add
        </Button>
      </Flex>
    </Style>
  );
};

const Style = styled(VFlex)`
  padding: 32px;
  width: 500px;
  ${modalStyle};
`;

export default AddSearchTabModal;
